import { mapState } from 'vuex';
import { NotificationMixins } from '../notification';

export const EssentialsAddToBasketMixins = {
  mixins: [NotificationMixins],
  data: function () {
    return {
      error: false,
      loading: false,
      selectedProduct: null,
      quantity: 1,
    };
  },
  computed: {
    ...mapState({
      orderId: (state) => state.orderId,
      order: (state) => state.order.order,
      user: (state) => state.user.user,
    }),
    selectedProductId: function () {
      return this.selectedProduct?.id || null;
    },
  },
  methods: {
    addToBasket() {
      return new Promise((resolve, reject) => {
        if (!this.selectedProductId) {
          return reject();
        }
        this.analyticsTrackAddItem();
        (this.user && this.user.id ? this.addItemToOrder : this.addItemToGuestCart)?.(this.selectedProduct).then(resolve).catch(reject);
      });
    },
    addItemToOrder(item) {
      return new Promise((resolve, reject) => {
        let details = {
          productId: item?.id,
          petId: this.pet?.id,
        };
        this.$store
          .dispatch('order/addLocalItems', {
            vm: this,
            orderId: this.orderId,
            items: Array.from({ length: this.quantity }, () => details),
            fetchOrderOnSuccess: true,
          })
          .then(() => {
            this.notifySuccess(`Item added.`, {
              family: 'AddItem',
              dismissSecs: 10,
              dismissible: true,
              class: 'text-center',
              showInLicensing: true,
            });
            resolve();
          })
          .catch(() => {
            this.notifyFailure(`Item could not be added.`, {
              family: 'AddItem',
              dismissSecs: 10,
              dismissible: true,
              class: 'text-center',
              showInLicensing: true,
            });
            reject();
          });
      });
    },
    addItemToGuestCart(item) {
      return new Promise((resolve, reject) => {
        const productData = {
          productId: item?.id,
        };
        this.$store
          .dispatch('order/storeLocalItems', {
            data: [productData],
            quantity: this.quantity,
            notificationOptions: { overrideDuplicate: true },
          })
          .then(resolve)
          .catch(reject);
      });
    },
    analyticsTrackAddItem() {
      if (window?.dataLayer && this.selectedProduct) {
        window?.dataLayer?.push({
          ecommerce: null,
        });
        const items = [];
        const _itemData = {
          quantity: this.quantity,
          coupon: this.order?.discount?.code || '',
          currency: `${this.order?.city?.country || 'US'}D`,
          item_list_id: this.productStyle?.id || '',
          item_list_name: this.productStyle?.code?.toUpperCase() || '',
        };
        items.push({
          ..._itemData,
          item_id: this.selectedProduct?.id || '',
          item_name: this.selectedProduct?.name?.toUpperCase() || '',
          item_category: this.selectedProduct?.type?.toUpperCase() || '',
          price: Number(this.selectedProduct?.discountedPrice || this.selectedProduct?.price || 0).toFixed(2),
        });
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: items,
            currency: `${this.order?.city?.country || 'US'}D`,
            value: Number(items?.reduce((p, c) => p + Number(c.price), 0)).toFixed(2),
          },
        });
      }
    },
  },
};
